import React from 'react';
export function FooterSection() {
  return <footer className="bg-navy-950 pt-8 md:pt-16 pb-6 md:pb-8 px-3 sm:px-6 lg:px-8 border-t border-navy-800" data-id="element-105">
      <div className="max-w-7xl mx-auto text-center" data-id="element-106">
        <h2 className="text-lg md:text-2xl font-black text-white mb-2 md:mb-4" data-id="element-107">
          GIMNASIA ARTÍSTICA RESUELTA™
        </h2>
        <p className="text-gray-400 max-w-2xl mx-auto mb-6 md:mb-12 text-xs md:text-base" data-id="element-108">
          El sistema de clases N°1 para profesores de gimnasia artística en
          Argentina. Porque enseñar artística no debería costarte todas las
          noches de la semana.
        </p>

        <div className="flex flex-col md:flex-row items-center justify-center space-y-2 md:space-y-0 md:space-x-8 mb-6 md:mb-12 text-gray-300 text-xs md:text-base" data-id="element-109">
          <a href="mailto:contacto@recursosfitness.shop" className="hover:text-gold-400 transition-colors" data-id="element-110">
            contacto@recursosfitness.shop
          </a>
          <span className="hidden md:block text-navy-700" data-id="element-111">•</span>
          <a href="#" className="hover:text-gold-400 transition-colors" data-id="element-112">
            @recursosfitness.ar
          </a>
          <span className="hidden md:block text-navy-700" data-id="element-113">•</span>
          <a href="#" className="hover:text-gold-400 transition-colors" data-id="element-114">
            recursosfitness.shop
          </a>
        </div>

        <div className="pt-4 md:pt-8 border-t border-navy-900 text-xs md:text-sm text-gray-600" data-id="element-115">
          © RecursosFitness™ 2026 — Todos los derechos reservados.
        </div>
      </div>
    </footer>;
}